import { memo } from 'react';
import { MobileOutlined } from '@ant-design/icons';
import SectionTitle from '../../../../../components/sharedcomponents/SectionTitle';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';

interface DeviceEntry {
  deviceCategory: string;
  browser: string;
  users: string;
  sessions: string;
}

interface DevicesTabProps {
  data: DeviceEntry[];
}

const DevicesTab = memo(({ data }: DevicesTabProps) => {
  const devices = data.slice(0, 10);

  return (
    <div>
      <SectionTitle>Appareils et Navigateurs</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {devices.map((d, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl border border-blue-100 shadow-sm p-5
                       hover:-translate-y-1 hover:shadow-lg transition-all duration-200"
          >
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center
                           bg-blue-50 border border-blue-100 text-blue-500"
              >
                <MobileOutlined />
              </div>
              <div>
                <p className="text-sm font-semibold text-blue-950 m-0">{d.deviceCategory}</p>
                <p className="text-xs text-slate-400 m-0">{d.browser}</p>
              </div>
            </div>

            <div className="flex justify-between text-xs">
              <span className="text-slate-500">Utilisateurs</span>
              <span className="font-bold text-blue-950">
                <AnimatedCounter end={parseInt(d?.users || '0')} duration={1000 + i * 150} />
              </span>
            </div>

            <div className="flex justify-between text-xs mt-1">
              <span className="text-slate-500">Sessions</span>
              <span className="font-bold text-blue-950">
                <AnimatedCounter end={parseInt(d?.sessions || '0')} duration={1100 + i * 150} />
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

DevicesTab.displayName = 'DevicesTab';

export default DevicesTab;